import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import {END_CLIENTS, GET_MT_SERVICE} from './endpoints';

@Injectable({
  providedIn: 'root'
})
export class EndclientService extends BaseService{

  constructor(http: HttpClient) { 
    super(http);
  }

  saveEndClient(data: {name: string}): any{
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*'
      }
    };
    return this.postRequest(END_CLIENTS , data, options);
  }
  getItems(iscompliance: boolean = null): Observable<any>{
    let url = END_CLIENTS + '?limit=0';
    if (iscompliance != null){
      url += '&iscompliance=' + iscompliance ? 'true' : 'false';
    }
    return this.getRequest(url, null);
  }
}
